

import __layout_0 from '/home/sphiere/backup-repo/fms-fe/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/home/sphiere/backup-repo/fms-fe/src/layouts/blank.vue'),
'default': __layout_0,
'landing': () => import('/home/sphiere/backup-repo/fms-fe/src/layouts/landing.vue'),
'components/AddColleague': () => import('/home/sphiere/backup-repo/fms-fe/src/layouts/components/AddColleague.vue'),
'components/DefaultLayoutWithHorizontalNav': () => import('/home/sphiere/backup-repo/fms-fe/src/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/home/sphiere/backup-repo/fms-fe/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/home/sphiere/backup-repo/fms-fe/src/layouts/components/Footer.vue'),
'components/NavBarNotifications': () => import('/home/sphiere/backup-repo/fms-fe/src/layouts/components/NavBarNotifications.vue'),
'components/NavSearchBar': () => import('/home/sphiere/backup-repo/fms-fe/src/layouts/components/NavSearchBar.vue'),
'components/NavbarShortcuts': () => import('/home/sphiere/backup-repo/fms-fe/src/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/home/sphiere/backup-repo/fms-fe/src/layouts/components/NavbarThemeSwitcher.vue'),
'components/UserProfile': () => import('/home/sphiere/backup-repo/fms-fe/src/layouts/components/UserProfile.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
